import React, { Component } from 'react';
import { ReactComponent as ArrowSvg} from './arrow.svg';

export default class Btn extends Component {
	constructor(props) {
		super(props);
		this.state = {
			step: 0,
		};
	}
	
	render() {
		const {color, arrow} = this.props;
		
		let classColor = '';
		let btnArrow = '';
		let classArrow = '';
		switch (color) {
			case 'black':
				classColor = 'btn--black';
				break;
			case 'test':
				classColor = 'btn--test';
				break;
		
			default:
				classColor = ''
				break;
		}
		switch (arrow) {
			case 'right':
				btnArrow = <ArrowSvg />;
				classArrow = 'btn--right';
				// console.log(arrowSvg);
				break;
				
			case 'left':
				btnArrow = <ArrowSvg />;
				classArrow = 'btn--left';
				// console.log(arrowSvg);
				break;
				
			default:
				btnArrow = ''
				break;
		}
		
		return (
			<button className={`btn ${classColor} ${classArrow} ${this.props.className}`} onClick={this.props.onClick}>
				<span>
				{this.props.children}  
				</span>
				{btnArrow}
			</button>
		);
	}
}
